export default class Action {
    undo() {}
    redo() {}
}